import React from "react";
import { useSelector } from "react-redux";
import PageWrapper from "../PageWrapper";
import { PaddedPaper } from "../../components/paper";
import Grid from "@material-ui/core/Grid";
import ContentWrapper from "../../components/contentWrapper/contentWrapper";
import PaymentViaCard from "../../components/paymentWidgets/paymentViaCard";
import PaymentPageHeader from "../../components/paymentWidgets/paymentPageHeader";
import { brands } from "@theme/config";
import environmentSettings from "@constants/environmentSettings";

export const Payment = () => {
  const { accountId } = useSelector((state) => state.Client);
  const { themeName } = useSelector(state => state.StartUp.brand);

  const { directDebitBank, directDebitBSB, directDebitAccountNumber } = environmentSettings;

  return (
    <PageWrapper>
      <PaddedPaper>
        <div className="page-wrapper page-wrapper-padded">
          <ContentWrapper>
            <Grid
              container
              spacing={2}
            >
              <Grid item xs={12}>
                <PaymentPageHeader
                  heading={"Make a one-off payment"}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
            >
              <Grid item xs={12} md={6} lg={4} xl={4}>
                <PaymentViaCard
                  heading={"Pay via Debit Card"}
                  subText={
                    "Use your Debit Card."
                  }
                  showButton={true}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={4} xl={4}>
                <PaymentViaCard
                  heading={"Pay via Direct Deposit"}
                  subText={
                    "Make a direct deposit into our bank account using the details below."
                  }
                  listElements={[
                    `Bank: ${directDebitBank}`,
                    `BSB: ${directDebitBSB}`,
                    `Account Number: ${directDebitAccountNumber}`,
                    `Reference: ${accountId || "[Your account number]"}`,
                  ]}
                />
              </Grid>

              {themeName !== brands.nimbleBrand.themeName && (
                <Grid item xs={12} md={6} lg={4} xl={4}>
                  <PaymentViaCard
                    heading={"Pay via PayID"}
                    subText={
                      "Make a payment via PayID using the details below."
                    }
                    listElements={[
                      "Name: FAIR GO FINANCE PTY LTD",
                      "PayID Type: ABN/Business Number",
                      "PayID: 18134369574",
                      "PayID Name: FAIR GO FINANCE PTY LTD",
                      `Reference: ${accountId || "Your Loan Number (it will be either 6 or 7 digits)"}`,
                    ]}
                  />
                </Grid>
              )}
            </Grid>
          </ContentWrapper>
        </div>
      </PaddedPaper>
    </PageWrapper>
  );
};
